var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinksDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.97 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4284a;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.27,52.71c20.01,20.02,39.98,39.99,60.14,60.16-.26.18-.64.38-.93.66-56.87,56.86-113.74,113.72-170.58,170.61-.81.81-1.59,1.13-2.73,1.13-18.99-.04-37.98-.03-56.97-.03h-1.48v-1.38c0-19.14,0-38.28-.02-57.42,0-.9.26-1.51.9-2.15,56.98-56.95,113.95-113.92,170.92-170.89.26-.26.53-.51.74-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,90.13C29.94,60.19,59.91,30.22,89.84.29c18.7,18.7,37.48,37.49,56.17,56.19-6.96,6.96-13.98,13.98-20.94,20.93-11.58-11.58-23.29-23.29-34.91-34.91-16.06,16.06-31.91,31.92-47.79,47.79,11.56,11.57,23.25,23.28,34.89,34.94-7.08,7.04-14.15,14.06-21.15,21.03C37.52,127.65,18.74,108.87,0,90.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.65,210.17c-29.93,29.93-59.9,59.9-89.83,89.83-18.7-18.7-37.48-37.48-56.17-56.17,6.97-7.01,13.99-14.07,20.98-21.1,11.67,11.66,23.38,23.35,34.98,34.94,15.94-15.94,31.79-31.79,47.67-47.67-11.57-11.57-23.27-23.27-34.86-34.86,7.08-7.08,14.12-14.12,21.09-21.09,18.62,18.62,37.39,37.39,56.13,56.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.16,90.1c-20.14-20.14-40.11-40.11-60.14-60.13.19-.2.43-.47.68-.73,8.12-8.12,16.23-16.24,24.35-24.36,6.51-6.51,15.6-6.52,22.12,0,12.66,12.65,25.32,25.3,37.97,37.97,6.46,6.46,6.44,15.58-.02,22.04-8.12,8.12-16.24,16.24-24.35,24.36-.26.26-.44.6-.62.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksDesign);
export default __webpack_public_path__ + "static/media/links_design.1fe49a03e6fc2023efa881c3d80e5209.svg";
export { ForwardRef as ReactComponent };